(function($) {
    $(document).ready(function(){
        if ($('#latest-news-articles').length) {
            $('#latest-news-articles').slick({
                arrows: false,
                dots: true,
                autoplay: true,
                autoplaySpeed: 5000,
                asNavFor: '#latest-news-images'
            });
        }
        if ($('#latest-news-images').length) {
            $('#latest-news-images').slick({
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                asNavFor: '#latest-news-articles'
            });
        }
    });
})( jQuery );
